export default __webpack_public_path__ + "static/media/NFGbanner.689d251a.png";